import styled from '@emotion/styled';
import { StyledProps } from './NavLinksContainer.types';
import { Theme } from '../Nav.types';
import css from '@styled-system/css';

export default styled.ul<StyledProps, Theme>`
  ${css({
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    listStyleType: 'none',
  })}
`;
